<template>
    <img v-if="displayImage" :src="source" class="file-image" />
    <file-form v-else :value="value" :filter="filter" :is-hover="isHover" />
</template>

<script>
    import axios from 'axios'

    export default {
        props: [
            'value',
            'filter',
            'isHover'
        ],

        components: {
            fileForm: () => import('../forms/FileForm')
        },

        data() {
            return {
                displayImage: false,
                source: '',
            }
        },

        watch: {
            value: {
                immediate: true,
                async handler() {
                    var response = await axios.get('/api/Files/Exists/' + this.value);
                    var fileExists = response.data;
                    if (fileExists) {
                        var fileResponse = await axios.get('/api/Files/FileIsImage/' + this.value);
                        var fileIsImage = fileResponse.data;
                        if (fileIsImage) {
                            this.source = `/api/Files/GetFile/${this.value}`;
                            this.displayImage = true;
                        }
                        else {
                            this.displayImage = false;
                        }
                    }
                    else {
                        this.displayImage = false;
                    }
                }
            }
        }
    };
</script>
<style scoped>
    .file-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
</style>
